var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeavyCheckNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3359,
    cy: 15,
    r: 15,
    fill: "#A9CF3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2834 9.93046C22.6449 10.3221 22.6402 10.9559 22.2683 11.3428L13.8844 20.0627C13.516 20.4459 12.9328 20.4459 12.5644 20.0627L8.38253 15.6755C8.00803 15.2861 8.00803 14.6548 8.38178 14.2661C8.75022 13.8829 9.33342 13.8829 9.70186 14.2661L13.2426 17.9643L20.9668 9.9342C21.3069 9.58047 21.83 9.55326 22.1983 9.85255L22.2834 9.93046Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavyCheckNew);
export default __webpack_public_path__ + "static/media/heavy_check_new.fff23be550ba534e2c30c3f3110852b4.svg";
export { ForwardRef as ReactComponent };